import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort, Sort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Paginable} from './model/paginable-interface';
import {TableEvent} from './model/table-event';
import {TableColumn} from './table-column';

@Component({
  selector: 'welfy-table',
  templateUrl: './welfy-table.component.html',
  styleUrls: ['./welfy-table.component.css'],
})
export class WelfyTable implements OnInit, AfterViewInit {
  public tableDataSource = new MatTableDataSource([]);
  public displayedColumns: string[];
  @ViewChild(MatPaginator, {static: false}) matPaginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) matSort: MatSort;

  @Input() isPageable = true;
  @Input() isSortable = false;
  @Input() isFilterable = false;
  @Input() tableColumns: TableColumn[];
  @Input() rowActionIcon: string;
  @Input() paginationSizes: number[] = [5, 10, 15, 20, 25];
  @Input() defaultPageSize = this.paginationSizes[1];

  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @Output() rowAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() page: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() tableEvent: EventEmitter<TableEvent> =
    new EventEmitter<TableEvent>();
  @Output() rowElementSelected: EventEmitter<any> = new EventEmitter<any>();

  // this property needs to have a setter, to dynamically get changes from parent component
  @Input() set tableData(data: Paginable<any>) {
    this.setTableDataSource(data);
  }

  private _totalElements = 0;

  ngOnInit(): void {
    const columnNames = this.tableColumns.map(
      (tableColumn: TableColumn) => tableColumn.name
    );
    if (this.rowActionIcon) {
      this.displayedColumns = [this.rowActionIcon, ...columnNames];
    } else {
      this.displayedColumns = columnNames;
    }
  }

  public get totalElements() {
    return this._totalElements;
  }

  ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.matPaginator;
    this.tableDataSource.sort = this.matSort;
  }

  setTableDataSource(data: Paginable<any>) {
    if (data) {
      this.tableDataSource = new MatTableDataSource<any>(data.content);
      this._totalElements = data.totalElements;
      this.matPaginator.length = data.totalElements;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableDataSource.filter = filterValue.trim().toLowerCase();
  }

  sortTable(sortParameters: Sort) {
    // defining name of data property, to sort by, instead of column name
    sortParameters.active = this.tableColumns.find(
      (column) => column.name === sortParameters.active
    ).dataKey;
    this.tableEvent.emit({
      page: {
        pageIndex: this.matPaginator.pageIndex,
        length: this.matPaginator.length,
        pageSize: this.matPaginator.pageSize,
      },
      sort: sortParameters,
    });
  }

  emitRowAction(row: any) {
    this.rowAction.emit(row);
  }

  nextPage(page: PageEvent) {
    let activeSort = '';

    if (this.matSort.active) {
      activeSort = this.tableColumns.find(
        (column) => column.name === this.matSort.active
      ).dataKey;
    }

    this.tableEvent.emit({
      page: page,
      sort: {
        active: activeSort,
        direction: this.matSort.direction,
      },
    });
  }

  rowClicked(columnName, element) {
    this.rowElementSelected.emit({
      column: columnName,
      value: element[columnName],
      rowValue: element
    });
  }
}
